export const XXE_CLIENT_VERSION = '1_7_1';
export const XXE_URL_PREFIX = '/xxe/' + XXE_CLIENT_VERSION + '/xxeclient/';
